import HTTP from './http'
const BASE_URL = '/factoring'

export default {
  /**
   * Get list of accounts pending a factoring decision
   * @param factoringProviderKeyfactoringProviderKey
   * @returns {Promise<*>}
   */
  async pendingApprovals(factoringProviderKey) {
    const params = {
      factoringProviderKey
    }
    const response = await HTTP.get(`${BASE_URL}/approval/list`, { params })
    return response.data.data
  },

  /**
   * Reject an account
   * @param factoringProviderKey
   * @param factoringProviderApprovalEntityType
   * @param factoringProviderApprovalEntityKey
   * @returns {Promise<*|Promise<*>>}
   */
  async reject({ factoringProviderKey, factoringProviderApprovalEntityType, factoringProviderApprovalEntityKey }) {
    const params = {
      factoringProviderKey,
      factoringProviderApprovalStatus: 'denied',
      factoringProviderApprovalEntityKey,
      factoringProviderApprovalEntityType
    }

    return this._setStatus(params)
  },

  /**
   * Approve an account
   * @param factoringProviderKey
   * @param factoringProviderApprovalEntityType
   * @param factoringProviderApprovalEntityKey
   * @returns {Promise<*|Promise<*>>}
   */
  async approve({ factoringProviderKey, factoringProviderApprovalEntityType, factoringProviderApprovalEntityKey }) {
    const params = {
      factoringProviderKey,
      factoringProviderApprovalStatus: 'approved',
      factoringProviderApprovalEntityKey,
      factoringProviderApprovalEntityType
    }
    return this._setStatus(params)
  },

  /**
   * Pre-approve a carrier
   * @param factoringProviderKey
   * @param factoringProviderApprovalEntityType
   * @param factoringProviderApprovalEntityKey
   * @returns {Promise<*|Promise<*>>}
   */
  async preApprove({ factoringProviderKey, factoringProviderApprovalEntityType, factoringProviderApprovalEntityKey }) {
    const params = {
      factoringProviderKey,
      factoringProviderApprovalStatus: 'preapproved',
      factoringProviderApprovalEntityKey,
      factoringProviderApprovalEntityType
    }
    return this._setStatus(params)
  },

  /**
   * Actually perform the approval or rejection
   * @param factoringProviderKey
   * @param factoringProviderApprovalStatus
   * @param factoringProviderApprovalEntityType
   * @param factoringProviderApprovalEntityKey
   * @returns {Promise<*>}
   * @private
   */
  async _setStatus({
    factoringProviderKey,
    factoringProviderApprovalStatus,
    factoringProviderApprovalEntityType,
    factoringProviderApprovalEntityKey
  }) {
    const params = {
      factoringProviderKey,
      factoringProviderApprovalStatus,
      factoringProviderApprovalEntityKey,
      factoringProviderApprovalEntityType
    }
    const response = await HTTP.post(`${BASE_URL}/approval`, { ...params })
    return response.data.data
  }
}
